import type { DefaultContext } from '@apollo/client/core'

export const BACKGROUND_OPERATION = { backgroundOperation: true } as const

export function isBackgroundOperation(context: DefaultContext): boolean {
  return context.backgroundOperation === true
}
